import {
  Card,
  CardBenefits,
  CardParams,
  CardRequest,
  CardsResponse,
} from '@/types/credit';
import { QueryRequest } from '@/utils/QueryRequest';

const BASE_URL = process.env.NEXT_PUBLIC_AFFILIATION_API_BASE_URL;
// Usado pelo sitemap: sem limite, uma API que não responde prende a requisição.
const SLUGS_TIMEOUT_MS = 10_000;

export async function getAllCards(params?: { country: string }) {
  const queryRequest = new QueryRequest<Card[]>(BASE_URL);
  queryRequest.addDefaultHeaders();
  queryRequest.addTags(['creditCard']);
  return queryRequest.get('cards', params);
}

export async function getFindCard(params?: CardParams) {
  const queryRequest = new QueryRequest<CardsResponse>(BASE_URL);
  queryRequest.addDefaultHeaders();
  return queryRequest.get(`cards/find`, params);
}

export async function getCardById(id: string) {
  const queryRequest = new QueryRequest<Card>(BASE_URL);
  queryRequest.addDefaultHeaders();
  return queryRequest.get(`cards/${id}`);
}

export async function getCardBySlug(slug: string) {
  const queryRequest = new QueryRequest<Card>(BASE_URL);
  queryRequest.addDefaultHeaders();
  queryRequest.addTags(['creditCard']);
  return queryRequest.get(`cards/slug/${slug}`);
}

export async function getCardSlugsAndCountryCodes() {
  const queryRequest = new QueryRequest<CardRequest>(BASE_URL);
  queryRequest.addDefaultHeaders();
  queryRequest.addTimeout(SLUGS_TIMEOUT_MS);
  return queryRequest.get('cards/slugs');
}

export async function getBenefits(params: { country: string }) {
  const benefitsRequest = new QueryRequest<CardBenefits>(BASE_URL);
  benefitsRequest.addDefaultHeaders();
  benefitsRequest.addTags(['creditCard']);
  return benefitsRequest.get(`cards/benefits`, params);
}

export async function getCardFinancialInstitutions(params: {
  country: string;
}) {
  const financialRequest = new QueryRequest<string[]>(BASE_URL);
  financialRequest.addDefaultHeaders();
  financialRequest.addTags(['creditCard']);
  return financialRequest.get(`cards/financialInstitutions`, params);
}
